import React from "react";
import styles from "./styles.module.scss";
import EventItem from "../event-item";

const NotificationCategory = ({ id, heading, events }) => {
  return (
    <section className={styles.container} id={id}>
      <h2 className={styles.heading}>{heading}</h2>

      {events?.map((event) => {
        return <EventItem key={`event-item-${event.id}`} event={event} />;
      })}
    </section>
  );
};

export default NotificationCategory;
